module.exports = __webpack_public_path__ + "img/ac6.4932cdfe.jpg";